import { render, staticRenderFns } from "./Visit.vue?vue&type=template&id=cd73718c&scoped=true&lang=html&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd73718c",
  null
  
)

export default component.exports